/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import * as Icon from "react-feather";
import { Link, NavLink } from "react-router-dom";
import { removeLocalStorageAdmin } from "../../../utils/Functions/removeLocalStorageAdmin";
import baseUrl from "../../../utils/baseUrl";

const SellerNavbar = (props) => {
  // Restore expanded menus from sessionStorage
  const [expandedMenus, setExpandedMenus] = React.useState(() => {
    try {
      const raw = sessionStorage.getItem("sellerSidebarExpandedMenus");
      return raw ? JSON.parse(raw) : {};
    } catch (err) {
      return {};
    }
  });

  // Top-level menus for accordion behavior
  const topLevelMenus = [
    "orders",
    "campaigns",
    "stores",
    "PurOrder",
    "PayAdvice",
  ];

  // Toggle menu function
  const toggleMenu = (menuKey) => {
    setExpandedMenus((prev) => {
      const isOpen = !!prev[menuKey];

      const isTopLevel = topLevelMenus.includes(menuKey);

      // Accordion rule for top-level menus
      const next = isTopLevel
        ? isOpen
          ? {}
          : topLevelMenus.reduce((acc, key) => {
              acc[key] = key === menuKey;
              return acc;
            }, {})
        : { ...prev, [menuKey]: !isOpen };

      try {
        sessionStorage.setItem(
          "sellerSidebarExpandedMenus",
          JSON.stringify(next),
        );
      } catch (err) {}

      return next;
    });
  };

  React.useEffect(() => {
    try {
      sessionStorage.setItem(
        "sellerSidebarExpandedMenus",
        JSON.stringify(expandedMenus),
      );
    } catch (err) {}
  }, [expandedMenus]);

  return (
    <aside className="sidebar" style={{ overflow: "visible" }}>
      <div className="scroll-sidebar" style={{ overflow: "hidden" }}>
        {/* USER PROFILE */}
        <div className="user-profile">
          <div className="dropdown user-pro-body">
            <div className="profile-image">
              <img
                src={baseUrl.concat(props.sellerProfileById?.sellerImageUrl)}
                alt="user-img"
                className="img-circle"
              />
              <Link
                to="#!"
                className="dropdown-toggle u-dropdown text-blue"
                data-toggle="dropdown"
                role="button"
              >
                <span className="badge badge-danger">
                  <i className="fa fa-angle-down"></i>
                </span>
              </Link>

              <ul className="dropdown-menu animated flipInY">
                <li>
                  <NavLink to="/SellerProfile">
                    <i className="fa fa-user"></i> Profile
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/EditSellerProfile">
                    <i className="fa fa-cog"></i> Settings
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/SellerLogin"
                    onClick={() => removeLocalStorageAdmin()}
                  >
                    <i className="fa fa-power-off"></i> Logout
                  </NavLink>
                </li>
              </ul>
            </div>

            <p
              className="profile-text m-t-15 font-16"
              style={{ textTransform: "capitalize" }}
            >
              <Link to="/SellerProfile">
                {props.sellerProfileById?.sellerName}
              </Link>
            </p>
          </div>
        </div>

        {/* SIDEBAR NAVIGATION */}
        <nav className="sidebar-nav">
          <ul id="side-menu">
            {/* Dashboard */}
            <li>
              <NavLink to="/SellerHome" aria-expanded="false">
                <Icon.Monitor className="text-dark fa-fw" />
                <span className="hide-menu"> Dashboard </span>
              </NavLink>
            </li>

            {/* Products */}
            <li>
              <NavLink to="/CreateProductSeller" aria-expanded="false">
                <Icon.HardDrive className="text-dark fa-fw" />
                <span className="hide-menu"> Products</span>
              </NavLink>
            </li>

            {/* Orders */}
            <li>
              <a
                className="waves-effect"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  toggleMenu("orders");
                }}
                aria-expanded={expandedMenus.orders || false}
              >
                <Icon.ShoppingCart className="text-dark fa-fw" />
                <span className="hide-menu"> Orders </span>
              </a>

              <ul
                aria-expanded={expandedMenus.orders || false}
                className={`collapse ${expandedMenus.orders ? "in" : ""}`}
              >
                <li>
                  <NavLink to="/ManageOrder?status=order_placed">
                    Manage Orders
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/CancelSellerOrders?status=cancel_request">
                    Cancel Orders
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/ReturnSellerOrders?status=return_request">
                    Return Orders
                  </NavLink>
                </li>
              </ul>
            </li>

            {/* Campaigns */}
            <li>
              <a
                className="waves-effect"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  toggleMenu("campaigns");
                }}
                aria-expanded={expandedMenus.campaigns || false}
              >
                <Icon.Percent className="text-dark fa-fw" />
                <span className="hide-menu"> Campaigns </span>
              </a>

              <ul
                aria-expanded={expandedMenus.campaigns || false}
                className={`collapse ${expandedMenus.campaigns ? "in" : ""}`}
              >
                <li>
                  <NavLink to="/SellerCampaignList?status=active">
                    Campaigns List
                  </NavLink>
                </li>
              </ul>
            </li>

            {/* Stores */}
            <li>
              <a
                className="waves-effect"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  toggleMenu("stores");
                }}
                aria-expanded={expandedMenus.stores || false}
              >
                <Icon.Package className="text-dark fa-fw" />
                <span className="hide-menu"> Stores </span>
              </a>

              <ul
                aria-expanded={expandedMenus.stores || false}
                className={`collapse ${expandedMenus.stores ? "in" : ""}`}
              >
                <li>
                  <NavLink to="/CreateSellerStoreBanner">
                    Store Banner Create
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/SellerStoreBannerList">
                    Store Banner List
                  </NavLink>
                </li>
              </ul>
            </li>

            {/* Purchase Order */}
            <li>
              <a
                className="waves-effect"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  toggleMenu("PurOrder");
                }}
                aria-expanded={expandedMenus.PurOrder || false}
              >
                <Icon.Clipboard className="text-dark fa-fw" />
                <span className="hide-menu"> Purchase Order </span>
              </a>

              <ul
                aria-expanded={expandedMenus.PurOrder || false}
                className={`collapse ${expandedMenus.PurOrder ? "in" : ""}`}
              >
                <li>
                  <NavLink to="/SellerReceivedPOList?page=1">
                    Received P.O. List
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/SellerReturnPOList?page=1">
                    Return P.O. List
                  </NavLink>
                </li>
              </ul>
            </li>

            {/* Payment Advice*/}
            <li>
              <a
                className="waves-effect"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  toggleMenu("PayAdvice");
                }}
                aria-expanded={expandedMenus.PayAdvice || false}
              >
                <Icon.Clipboard className="text-dark fa-fw" />
                <span className="hide-menu"> Payment Advice </span>
              </a>

              <ul
                aria-expanded={expandedMenus.PayAdvice || false}
                className={`collapse ${expandedMenus.PayAdvice ? "in" : ""}`}
              >
                <li>
                  <NavLink to="/SellerPaymentAdviceList?page=1">
                    Payment Advice List
                  </NavLink>
                </li>
              </ul>
            </li>

            {/* Settings */}
            <li>
              <NavLink to="/BusinessInformation" aria-expanded="false">
                <Icon.Settings className="text-dark fa-fw" />
                <span className="hide-menu"> Account &amp; Settings </span>
              </NavLink>
            </li>
          </ul>
        </nav>
      </div>
    </aside>
  );
};

export default SellerNavbar;
